module.exports = __webpack_public_path__ + "static/img/app-store.db4f365.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app-store.svg
// module id = 322
// module chunks = 1